import { PreScreeningQuestion } from "../../types/landingPage";
import { AttributeValueInput, QuestionnaireAnswers } from "./types";
import { filterPlaceholderAttributes } from "./filterPlaceholders";
import { withScope, captureException } from "@sentry/react";

export interface MappingContext {
  countryCode: string;
  allAnswers: QuestionnaireAnswers;
}

export function mapQuestionnaireToAttributes(
  questionnaireAnswers: QuestionnaireAnswers,
  screenerQuestions: PreScreeningQuestion[],
  countryCode: string
): AttributeValueInput[] {
  const allAttributes: AttributeValueInput[] = [];
  const context: MappingContext = {
    countryCode,
    allAnswers: questionnaireAnswers,
  };

  for (const question of screenerQuestions) {
    const response = questionnaireAnswers[question.id];

    if (response !== undefined && question.attributeMapping) {
      try {
        const mappedAttributes = question.attributeMapping(response, context);
        allAttributes.push(...mappedAttributes);
      } catch (error) {
        // As per the PRD, mappers should not crash the process.
        // Log the error to Sentry with context for debugging.
        withScope((scope) => {
          scope.setTag("location", "attributeMapper");
          scope.setContext("questionContext", {
            questionId: question.id,
            response,
            countryCode: context.countryCode,
          });
          captureException(error);
        });
      }
    }
  }

  // Filter out placeholder attributes (ID: 999999) before returning
  return filterPlaceholderAttributes(allAttributes);
} 